export default "__VITE_ASSET__85a3930c__"